/**
* 状态管理仓库
*/
import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

// 模块
import common from './modules/common'
import act from './modules/act'
import account from './modules/account'

Vue.use(Vuex)

const plugins: any[] = []
/* if (process.env.NODE_ENV !== 'dev') {
  plugins.push(
    createPersistedState({ storage: window.sessionStorage })
  )
} */

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    common,
    act,
    account
  },
  plugins
})

export default store
